import { jwtDecode } from "jwt-decode";

const Authorize = ({ roles, children }) => {

  const token = sessionStorage.getItem("jwtToken");
  const decoded = jwtDecode(token);
  if (!decoded) {
    return null;
  }
  const userRole = decoded.role;

  const allowed = roles.includes(userRole);

  return allowed? children: null;
};

export default Authorize;